import { render, staticRenderFns } from "./Helps.vue?vue&type=template&id=192108dd&scoped=true&"
import script from "./Helps.vue?vue&type=script&lang=js&"
export * from "./Helps.vue?vue&type=script&lang=js&"
import style0 from "./Helps.vue?vue&type=style&index=0&id=192108dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192108dd",
  null
  
)

export default component.exports